import React from "react";

export const ProfessionalInfoStep = ({ formData, onChange }) => (
  <React.Fragment>
    <div className="grid-item">
      <input
        name="affiliation"
        placeholder="Affiliation *"
        value={formData.affiliation}
        onChange={onChange}
        required
      />
    </div>
    <div className="grid-item">
      <input
        name="institution"
        placeholder="Institution or Hospital Name *"
        value={formData.institution}
        onChange={onChange}
        required
      />
    </div>
    <div className="grid-item">{/* Specialization field hidden as requested */}</div>
   
    <div className="grid-item grid-item--radio">
      <label className="radio-label">Do you have MCI Number?</label>
      <div className="radio-row">
        <label>
          <input
            type="radio"
            name="mciRegistered"
            value="Yes"
            checked={formData.mciRegistered === "Yes"}
            onChange={onChange}
          />{" "}
          Yes
        </label>
        <label>
          <input
            type="radio"
            name="mciRegistered"
            value="No"
            checked={formData.mciRegistered === "No"}
            onChange={onChange}
          />{" "}
          No
        </label>
      </div>
      {formData.mciRegistered === "Yes" && (
        <input
          name="mciNumber"
          placeholder="Enter MCI Number *"
          value={formData.mciNumber}
          onChange={onChange}
          required
        />
      )}
    </div>
  </React.Fragment>
);
